<template>
  <div class="login">
    <a-form @submit.prevent="doLogin" :autoFormCreate="(form) => this.form = form">
      <a-tabs size="large" :tabBarStyle="{textAlign: 'center'}" style="padding: 0 2px;" :activeKey="activeKey"
              @change="handleTabsChange">
        <a-tab-pane tab="手机号验证码登录" key="2">
          <a-alert type="error" :closable="true" v-show="error" :message="error" showIcon
                   style="margin-bottom: 24px;"></a-alert>
          <a-form-item
            fieldDecoratorId="phone"
            :fieldDecoratorOptions="{rules: [{ required: true, message: '请输入手机号', whitespace: true}]}">
            <a-input size="large" placeholder="请输入手机号">
              <a-icon slot="prefix" type="user"></a-icon>
            </a-input>
          </a-form-item>
          <a-form-item
            fieldDecoratorId="verificationCode">
            <Verify @success="verifySuccess"
              :mode="mode"
              :captchaType="captchaType"
              :imgSize="{ width: '388px', height: '194px' }"
              ref="verify"></Verify>
          </a-form-item>
          <a-form-item
            fieldDecoratorId="authCode"
            :fieldDecoratorOptions="{rules: [{ required: true, message: '请输入验证码', whitespace: true}]}">
            <div style="display: flex;justify-content: space-between;">
              <a-input size="large" placeholder="请输入验证码" style="width: 50%">
                <a-icon slot="prefix" type="safety"></a-icon>
              </a-input>
              <!--60秒后重新获取-->
              <div class="captcha" :class="{activeCaptcha: isShowCaptcha}"
                    @click="getCaptcha">
                {{content}}
              </div>
            </div>
          </a-form-item>
        </a-tab-pane>
        <!--<a-tab-pane tab="手机号登录" key="2">
          <a-form-item>
            <a-input size="large">
              <a-icon slot="prefix" type="mobile"></a-icon>
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-row :gutter="8" style="margin: 0 -4px">
              <a-col :span="16">
                <a-input size="large">
                  <a-icon slot="prefix" type="mail"></a-icon>
                </a-input>
              </a-col>
              <a-col :span="8" style="padding-left: 4px">
                <a-button style="width: 100%" class="captcha-button" size="large" @click="getCaptcha">获取验证码</a-button>
              </a-col>
            </a-row>
          </a-form-item>
        </a-tab-pane>-->
      </a-tabs>
      <a-form-item
        fieldDecoratorId="rememberMe">
        <a-checkbox>记住我</a-checkbox>
        <span style="font-size: 12px;color: #f64343;">您的登陆信息会保存30天，请在安全的电脑上使用此功能!</span>
      </a-form-item>
      <a-form-item>
        <a-button :loading="loading" style="width: 100%; margin-top: 4px" size="large" htmlType="submit" type="primary">
          登录
        </a-button>
      </a-form-item>
      <div>
<!--        <a style="float: right" @click="regist">注册账户</a>-->
      </div>
    </a-form>
  </div>
</template>

<script>
import Verify from '@/components/verifition/Verify'
import {mapMutations} from 'vuex'

export default {
  name: 'Login',
  components: {
    Verify
  },
  data () {
    return {
      loading: false,
      error: '',
      activeKey: '2',
      page:'',
      mode: 'fixed',
      captchaType: 'clickWord',
      isShowCaptcha: false,
      totalTime: 60,
      content: '获取短信验证码',
      clock: null,
      rememberMe: false,
      verifyParams: {}
    }
  },
  computed: {
    systemName () {
      return this.$store.state.setting.systemName
    },
    copyright () {
      return this.$store.state.setting.copyright
    }
  },
  created () {
    this.$db.clear()
    this.$router.options.routes = []
  },
  mounted() {
    let code = this.$route.query.code
    if(!code){
      return
    }
    let params = {}
    params.code = code
    this.$post("api/verifyChangShanLogin", params).then(res => {
      let data = res.data.data
      this.saveLoginData(data)
      setTimeout(() => {
        this.loading = false
      }, 200)
      if(this.page){
        location.href = this.page
      }else{
        this.$router.push('/xunjian/record')
      }
    }).catch((e) => {
      console.error(e)
      setTimeout(() => {
        this.loading = false
      }, 500)
    })

  },
  methods: {
    doLogin () {
      if (this.activeKey === '2') {
        // 手机验证码登录
        this.form.validateFields(['phone', 'authCode'], (errors, values) => {
          if(!errors){
            console.log("validateFields", values)
            let phone = this.form.getFieldValue("phone")
            let authCode = this.form.getFieldValue("authCode")
            let rememberMe = this.form.getFieldValue("rememberMe")
            if(rememberMe === undefined){
              rememberMe = false
            }
            let verifyParams = this.verifyParams;
            let params = {}
            params.phone = phone
            params.authCode = authCode
            params.rememberMe = rememberMe
            params.captchaVO = verifyParams
            this.$postJson('/login/authCode', params).then(res => {
              console.log("loginAuthCode", res)
              let data = res.data.data
              this.saveLoginData(data)
              setTimeout(() => {
                this.loading = false
              }, 500)
              if(this.page){
                location.href = this.page
              }else if(data.user.streetId==821530){
                window.location.href = 'http://county.jinchanhb.com';
              }else {
                this.$router.push('/')
              }
            }).catch((e) => {
              console.error(e)
              setTimeout(() => {
                this.loading = false
              }, 500)
            })
          }
        })
      }
    },
    regist () {
      this.$emit('regist', 'Regist')
    },
    getCaptcha () {
      let phone = this.form.getFieldValue('phone')
      if(phone === ''){
        this.$message.warning('请先填写手机号')
        return
      }
      if(!this.isShowCaptcha){
        this.$message.warning('请完成滑动认证')
        return
      }
      if(this.clock !== null){
        this.$message.warning('请误重复发送短信验证码')
        return
      }
      let params = {}
      params.phone = phone
      this.$get("api/login/verification/code", params).then(res => {
        console.log("verificationCode: ", res)
      })
      this.content = this.totalTime + 's后重新发送'
      this.clock = setInterval(()=> {
        this.totalTime --
        this.content = this.totalTime + 's后重新发送'
        if(this.totalTime < 0){
          clearInterval(this.clock)
          this.clock = null
          this.content = '重新发送短信验证码'
          this.totalTime = 60
          this.isShowCaptcha = false
        }
      }, 1000)
    },
    handleTabsChange (val) {
      this.activeKey = val
    },
    ...mapMutations({
      setToken: 'account/setToken',
      setExpireTime: 'account/setExpireTime',
      setArea: 'account/setArea',
      setPermissions: 'account/setPermissions',
      setRoles: 'account/setRoles',
      setUser: 'account/setUser',
      setTheme: 'setting/setTheme',
      setLayout: 'setting/setLayout',
      setMultipage: 'setting/setMultipage',
      fixSiderbar: 'setting/fixSiderbar',
      fixHeader: 'setting/fixHeader',
      setColor: 'setting/setColor'
    }),
    saveLoginData (data) {
      this.setToken(data.token)
      this.setExpireTime(data.exipreTime)
      this.setUser(data.user)
      this.setPermissions(data.permissions)
      this.setRoles(data.roles)
      if(data.config){
        this.setTheme(data.config.theme)
        this.setLayout(data.config.layout)
        this.setMultipage(data.config.multiPage === '1')
        this.fixSiderbar(data.config.fixSiderbar === '1')
        this.fixHeader(data.config.fixHeader === '1')
        this.setColor(data.config.color)
      }
      this.setArea(data.user.areaStr)
      this.setCookie("username",data.user.username,3000);
      this.setCookie("token",data.token,3000);
    },
    setCookie(name,value,days){
      /*let Days = days;
      let exp = new Date();
      exp.setTime(exp.getTime() + Days*24*60*60*30);
      document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString();*/
      let domain, domainParts, date, expires, host;
      if(days){
        date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        expires = "; expires="+date.toGMTString();
      }else {
        expires = "";
      }
      host = location.host;
      if(host.split('.').length === 1){
        document.cookie = name+"="+value+expires+"; path=/";
      }else{
        /*domainParts = host.split('.');
        domainParts.shift();
        domain = '.'+domainParts.join('.');*/
        if(host.indexOf(":") != -1){
          host = host.substring(0,host.indexOf(":"));
        }
        document.cookie = name+"="+value+expires+"; path=/; domain="+host;
      }
    },
    verifySuccess(params){
      console.log("verifySuccess: ", params)
      if(params){
        this.verifyParams = params
        this.isShowCaptcha = true
      }
    },
    onRememberMe(){

    }
  },
  destroyed() {
    clearInterval(this.clock)
    this.clock = null
  }
}
</script>

<style lang="less" scoped>
  .login {
    .icon {
      font-size: 24px;
      color: rgba(0, 0, 0, 0.2);
      margin-left: 16px;
      vertical-align: middle;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: #1890ff;
      }
    }
    .captcha{
      width: 40%;
      border-radius: 10px;
      background-color: #fdf3d0;
      color: #909399;
      text-align: center;
      cursor: pointer;
    }
    .activeCaptcha{
      background-color: #ff9900 ;
      color: #ffffff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/login/Login.vue